"use strict";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
import smoothscroll from "smoothscroll-polyfill";
import "pace-progressbar";
import { addClassWithScroll as scroll } from "./common/_scroll-event";
gsap.registerPlugin(EaselPlugin, ScrollTrigger);
/**
 * スクロールイベント登録
 */
window.addEventListener(
  "scroll",
  function () {
    scroll(
      ".sp01-cont__main--01 .sp01-cont-txt",
      ".trigger-02",
      "is-active",
      "8"
    );
    scroll(
      ".sp01-cont-fig--pc.sp01-cont-fig--01",
      ".trigger-02",
      "is-active",
      "8"
    );
    scroll(
      ".sp01-cont-fig--sp.sp01-cont-fig--01",
      ".sp01-cont-fig--01",
      "is-active",
      "8"
    );
    scroll(".trigger-03 .anime-obj", ".trigger-03", "is-anime", "8");
    scroll(
      ".sp01-cont__main--02 .sp01-cont-txt",
      ".trigger-05",
      "is-active",
      "8"
    );
    scroll(
      ".sp01-cont-fig--pc.sp01-cont-fig--02",
      ".trigger-05",
      "is-active",
      "8"
    );
    scroll(
      ".sp01-cont-fig--sp.sp01-cont-fig--02",
      ".sp01-cont-fig--02",
      "is-active",
      "8"
    );
    scroll(".trigger-06 .anime-obj", ".trigger-06", "is-anime", "8");

    scroll(
      ".sp01-cont__main--03 .sp01-cont-txt",
      ".trigger-07",
      "is-active",
      "8"
    );
    scroll(
      ".sp01-cont-fig--pc.sp01-cont-fig--03",
      ".trigger-07",
      "is-active",
      "8"
    );
    scroll(
      ".sp01-cont-fig--sp.sp01-cont-fig--03",
      ".sp01-cont-fig--03",
      "is-active",
      "8"
    );
    scroll(".trigger-08 .anime-obj", ".trigger-08", "is-anime", "8");
  },
  false
);

gsap
  .timeline({
    defaults: {
      ease: "power2.out",
      duration: 1,
    },
    scrollTrigger: {
      // markers: true,
      trigger: ".sp01-member-profile", // この要素と交差するとイベントが発火
      start: "top 50%", // ウィンドウのどの位置を発火の基準点にするか
      end: "bottom top", // ウィンドウのどの位置をイベントの終了点にするか
    },
  })
  .to(".sp01-member-profile__item", {
    y: 0,
    opacity: 1,
  });

gsap
  .timeline({
    defaults: {
      ease: "power2.out",
      duration: 0.7,
    },
    scrollTrigger: {
      // markers: true,
      trigger: ".trigger-01", // この要素と交差するとイベントが発火
      start: "top 50%", // ウィンドウのどの位置を発火の基準点にするか
      end: "bottom top", // ウィンドウのどの位置をイベントの終了点にするか
    },
  })
  .to(
    ".sp01-cont-ttl__fig--01-01",
    {
      x: 0,
      opacity: 1,
    },
    "-=0.3"
  )
  .to(
    ".sp01-cont-ttl__fig--01-02",
    {
      x: 0,
      opacity: 1,
    },
    "-=0.3"
  )
  .to(
    ".sp01-cont-ttl-icon__main--01",
    {
      scale: 1,
      opacity: 1,
      duration: 0.8,
    },
    "-=0.5"
  )
  .add(function () {
    document
      .querySelector(".sp01-cont-ttl-icon__main--01")
      .classList.add("is-active");
  }, "+=0")
  .to(
    ".sp01-cont-ttl-main__inner--01",
    {
      y: 0,
      duration: 0.8,
    },
    "-=0.5"
  )
  .to(
    ".sp01-cont-ttl-lead__inner--01",
    {
      y: 0,
      duration: 0.8,
    },
    "-=0.5"
  );

gsap
  .timeline({
    defaults: {
      ease: "power2.out",
      duration: 1,
    },
    scrollTrigger: {
      // markers: true,
      trigger: ".trigger-04", // この要素と交差するとイベントが発火
      start: "top 50%", // ウィンドウのどの位置を発火の基準点にするか
      end: "bottom top", // ウィンドウのどの位置をイベントの終了点にするか
    },
  })
  .to(
    ".sp01-cont-ttl__fig--02-01",
    {
      y: 0,
      x: 0,
      opacity: 1,
    },
    "-=0.3"
  )
  .to(
    ".sp01-cont-ttl__fig--02-02",
    {
      x: 0,
      opacity: 1,
    },
    "-=0.3"
  )
  .to(
    ".sp01-cont-ttl-icon__main--02",
    {
      scale: 1,
      opacity: 1,
      duration: 0.8,
    },
    "-=0.5"
  )
  .add(function () {
    document
      .querySelector(".sp01-cont-ttl-icon__main--02")
      .classList.add("is-active");
  }, "+=0")
  .to(
    ".sp01-cont-ttl-main__inner--02",
    {
      y: 0,
      duration: 0.8,
    },
    "-=0.5"
  )
  .to(
    ".sp01-cont-ttl-lead__inner--02",
    {
      y: 0,
      duration: 0.8,
    },
    "-=0.5"
  );

gsap
  .timeline({
    defaults: {
      ease: "power2.out",
      duration: 1,
    },
    scrollTrigger: {
      // markers: true,
      trigger: ".trigger-06", // この要素と交差するとイベントが発火
      start: "top 50%", // ウィンドウのどの位置を発火の基準点にするか
      end: "bottom top", // ウィンドウのどの位置をイベントの終了点にするか
    },
  })
  .to(
    ".sp01-cont-ttl__fig--03-01",
    {
      xPercent: 0,
      opacity: 1,
    },
    "-=0.3"
  )
  .to(
    ".sp01-cont-ttl__fig--03-02",
    {
      x: 0,
      opacity: 1,
    },
    "-=0.3"
  )
  .to(
    ".sp01-cont-ttl-icon__main--03",
    {
      scale: 1,
      opacity: 1,
      duration: 0.8,
    },
    "-=0.5"
  )
  .add(function () {
    document
      .querySelector(".sp01-cont-ttl-icon__main--03")
      .classList.add("is-active");
  }, "+=0")
  .to(
    ".sp01-cont-ttl-main__inner--03",
    {
      y: 0,
      duration: 0.8,
    },
    "-=0.5"
  )
  .to(
    ".sp01-cont-ttl-lead__inner--03",
    {
      y: 0,
      duration: 0.8,
    },
    "-=0.5"
  );
